export async function fetchJson(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...(options.headers || {}),
    },
  })
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response.json()
}

// Fire-and-forget JSON post. `keepalive` so a ping sent as the visitor leaves the page still
// arrives, and errors are swallowed — nothing here is worth interrupting them over.
export function postJson(url, body) {
  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
        ?.content,
    },
    body: JSON.stringify(body),
  }).catch(() => {
    // silently ignore network errors and an expired session — nothing here is worth
    // interrupting the visitor over
  })
}

export function loadHtmlInto(target, data) {
  if (!data?.html) return
  target.innerHTML = data.html
  target.dispatchEvent(new Event('Changed', { bubbles: true }))
}

export function showErrorTemplate(target, errorTemplate) {
  if (errorTemplate) {
    target.replaceChildren(errorTemplate.content.cloneNode(true))
  }
}
